import React from "react";
import { Input, DatePicker, Toggle, DateTimePicker } from "../../../shared";
import { formatCurrency } from "@/utils";
import { useConfig } from "@/hooks";
import { getProductTerminology } from "@/constants/product-terminology";

const LoadAndRateInfo = ({
  form,
  handleInputChange,
  handleDateChange,
  handleRateChange,
}) => {
  const { appType } = useConfig();
  const terms = getProductTerminology(appType);

  return (
    <div>
      <div className="flex justify-between items-center border-b border-neutral-300 pb-2 mb-2">
        <h3 className="text-sm font-semibold text-neutral-700 uppercase tracking-wide">
          {terms.loadInformationSection}
        </h3>
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-neutral-700">
            Use Flat Rate
          </span>
          <Toggle
            id="useFlatRate"
            size="sm"
            checked={form.useFlatRate || false}
            onChange={(e) => {
              // console.log("useFlatRate", e);
              handleInputChange({
                id: "useFlatRate",
                value: e.target.checked,
              });
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-2">
        <Input
          id="loadNumber"
          label="Load Number"
          placeholder="Enter load number"
          value={form.loadNumber || ""}
          onChange={(e) =>
            handleInputChange({
              id: "loadNumber",
              value: e.value,
            })
          }
          required
          size="sm"
        />
        <DateTimePicker
          id="transactionDate"
          labels={{
            date: "Transaction Date",
            time: "Transaction Time",
          }}
          placeholder="Select date and time"
          value={form.transactionDate || ""}
          onChange={handleDateChange}
          size="sm"
        />
      </div>

      {/* Rate Fields */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {form.useFlatRate ? (
          <Input
            id="flatRate"
            label="Flat Rate"
            placeholder="0.00"
            type="number"
            step="0.01"
            min="0"
            value={form.flatRate || ""}
            onChange={(e) => handleRateChange("flatRate", e.value)}
            icon={{
              left: <div className="text-neutral-500 text-sm">$</div>,
            }}
            size="sm"
          />
        ) : (
          <>
            <Input
              id="baseRate"
              label="Base Rate"
              placeholder="0.00"
              type="number"
              step="0.01"
              min="0"
              value={form.baseRate || ""}
              onChange={(e) => handleRateChange("baseRate", e.value)}
              icon={{
                left: <div className="text-neutral-500 text-sm">$</div>,
              }}
              size="sm"
            />
            <Input
              id="fuelRate"
              label="Fuel Rate"
              placeholder="0.00"
              type="number"
              step="0.01"
              min="0"
              value={form.fuelRate || ""}
              onChange={(e) => handleRateChange("fuelRate", e.value)}
              icon={{
                left: <div className="text-neutral-500 text-sm">$</div>,
              }}
              size="sm"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default LoadAndRateInfo;
